export default {"src":"/_next/static/media/patronat.265c5b7b.svg","height":22,"width":134,"blurWidth":0,"blurHeight":0};